import React, { useEffect } from "react";
import { Formik, Field } from "formik";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  SearchableList,
  Link,
  MultiSelectDropdown,
} from "../../../components";
import {
  getPathWithParam,
  usDateFormat,
  MANAGE_RKAAS_ROUTES,
  getTwoDecimalPlaces,
} from "../../../utils";
import { getLedgers } from "../../../services";
import { Button, Form } from "react-bootstrap";
const columns = [
  {
    label: "Date",
    className: "column-planName col-md-2",
    columnName: "date",
  },
  {
    label: "Particulars",
    className: "column-planName col-md-2",
    columnName: "particulars",
  },
  {
    label: "Description",
    className: "column-status col-md-2",
    columnName: "description",
  },
  {
    label: "Increase",
    className: "column-status col-md-2",
    columnName: "increase",
  },
  {
    label: "Decrease",
    className: "column-status col-md-2",
    columnName: "decrease",
  },
  {
    label: "Balance",
    className: "column-planName col-md-2",
    columnName: "balance",
  },
];
const data = [
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 0,
    decrease: 102123,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
  {
    date: "29/10/2022",
    particulars: "sponsor employer recievable amount",
    description: "something",
    increase: 102123,
    decrease: 0,
    balance: 442246,
  },
];
const fields = {
  startDate: "startDate",
  endDate: "endDate",
  ledgerName: "ledgerName",
};
const selectLedgerNames = [
  {
    label: "plan source investment",
    value: 1,
  },
  {
    label: "plan source investment",
    value: 2,
  },
  {
    label: "plan source investment",
    value: 3,
  },
  {
    label: "plan source investment",
    value: 4,
  },
  {
    label: "plan source investment",
    value: 5,
  },
];
const LedgersContainer = (props) => {
  const payload = {
    planId: 0,
    fromDate: "2022-12-08T13:08:04.366Z",
    toDate: "2022-12-08T13:08:04.366Z",
  };
  useEffect(() => {
    getLedgers(payload)
      .then((res) => {
        if (res) {
        }
      })
      .catch((err) => err);
  }, []);
  const onFormSubmit = () => {};
  return (
    <div>
      <Formik initialValues={{}} onSubmit={onFormSubmit} enableReinitialize>
        {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
              <div className="d-flex" style={{ alignItems: "center" }}>
                <div className="ml-3">
                  <Field
                    size="sm"
                    isRequired
                    label="Ledger name"
                    name={fields.ledgerName}
                    value={values[fields.ledgerName]}
                    placeholder="Select"
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        options={selectLedgerNames}
                        onSelect={(value) =>
                          setFieldValue(fields.ledgerName, value)
                        }
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="ml-3">
                  <Button
                    type="button"
                    className="add-btn"
                    variant="secondary"
                    style={{
                      height: "fit-content",
                      fontSize: "0.75rem",
                      marginTop: "10%",
                    }}
                  >
                    This month
                  </Button>
                </div>
                <div className="ml-3">
                  <Button
                    type="button"
                    className="add-btn"
                    variant="secondary"
                    style={{
                      height: "fit-content",
                      fontSize: "0.75rem",
                      marginTop: "10%",
                    }}
                  >
                    Last month
                  </Button>
                </div>
                <div className="ml-3">
                  <Field
                    size="smd"
                    label={fields.startDate}
                    name={fields.startDate}
                    value={usDateFormat(values[fields.startDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.startDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.startDate, value)
                        }
                        value={usDateFormat(values[fields.payDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="ml-3">
                  <Field
                    size="smd"
                    label={fields.endDate}
                    name={fields.endDate}
                    value={usDateFormat(values[fields.endDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.endDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.endDate, value)
                        }
                        value={usDateFormat(values[fields.endDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div style={{ marginLeft: "3rem" }}>
                  <Link to={MANAGE_RKAAS_ROUTES.RKAS}>
                    <Button
                      type="button"
                      className="add-btn"
                      variant="primary"
                      style={{ height: "fit-content" }}
                    >
                      Back
                    </Button>
                  </Link>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table>
        <Table.Thead>
          <Table.Tr>
            {columns.map((item, index) => {
              return (
                <Table.Th key={index} className={item.className}>
                  {item.label}
                </Table.Th>
              );
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((e, i) => {
            return (
              <Table.Tr key={i}>
                {columns.map((item, cellIndex) => {
                  const getContent = () => {
                    if (typeof e[item.columnName] === "string") {
                      return e[item.columnName];
                    }
                    return `$ ${getTwoDecimalPlaces(e[item.columnName])}`;
                  };
                  return (
                    <Table.Td key={cellIndex} className={item.className}>
                      {getContent()}
                    </Table.Td>
                  );
                })}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </div>
  );
};
export default LedgersContainer;
